import React, { useState } from 'react';
import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../redux/actions/userAction';
import { IoMdLogOut } from 'react-icons/io';
import { FaUser } from 'react-icons/fa';
import { MdDashboard, MdViewList } from 'react-icons/md';
import { Backdrop } from '@mui/material';
import { BsCartCheckFill } from 'react-icons/bs';

const UserOptions = ({ user }) => {
    const dispatch = useDispatch();
    const { cartItems } = useSelector((state) => state.cart);
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();

    const dashboard = () => navigate('/admin/dashboard');
    const orders = () => navigate('/orders');
    const account = () => navigate('/account');
    const cart = () => navigate('/cart');

    const logOutUser = () => {
        dispatch(logout());
        toast.success('Logged out successfully!');
        navigate('/');
    };

    const actions = [
        { icon: <MdViewList />, name: 'Orders', func: orders },
        { icon: <FaUser />, name: 'Profile', func: account },
        {
            icon: <BsCartCheckFill style={{ color: cartItems.length > 0 ? '#6200ea' : 'unset' }} />,
            name: `Cart(${cartItems.length})`,
            func: cart,
        },
        { icon: <IoMdLogOut />, name: 'Logout', func: logOutUser },
    ];

    if (user?.role === 'admin') {
        actions.unshift({ icon: <MdDashboard />, name: 'Dashboard', func: dashboard });
    }

    return (
        <>
            <Backdrop open={open} style={{ zIndex: '11' }} />
            <SpeedDial
                direction={'down'}
                ariaLabel='User Options'
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                sx={{ position: 'fixed', top: 16, right: 16 }}
                icon={<img src='/assets/images/me.jpg' className='sppedDialImg' />}
            >
                {actions.map((action) => (
                    <SpeedDialAction
                        key={action.name}
                        icon={action.icon}
                        tooltipTitle={action.name}
                        onClick={action.func}
                        tooltipOpen={window.innerWidth <= 600 ? true : false}
                    />
                ))}
            </SpeedDial>
        </>
    );
};

export default UserOptions;
